import React from 'react';
/* import commonUtil from '../../../utils/commonUtil';
   const defaultImage = commonUtil.getAssetURL() + '/images/addImageIcon.svg'; */

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.loadCounter = 0;
  }
  // send alternate image path using altImg attribute.
  handleImageError = (e) => {
    if (this.props.imageAttr.altImg && this.loadCounter <= 3) {
      e.target.src = this.props.imageAttr.altImg;
    } else {
      // e.target.src = defaultImage;
    }
    this.loadCounter = this.loadCounter + 1;
  }
  render() {
    const tempSrc = this.props.imageAttr.src ? this.props.imageAttr.src : '';
    const { heightPicture, flexPicture, alignPicture, maxHeightPicture, maxWidthPicture } = this.props.imageAttr.pictureHtmlStyle || {};

    return (
      <picture
        style={{
          height: heightPicture || 'auto',
          display: flexPicture || 'initial',
          alignItems: alignPicture || 'start',
          maxHeight: maxHeightPicture || 'auto',
          maxWidth: maxWidthPicture || 'auto',
        }}
        className={`picture_container ${this.props?.imageAttr?.pictureClassName || ''}`}
      >
        <img
          id={this.props.imageAttr.id} src={tempSrc}
          alt={this.props.imageAttr.alt} height={this.props.imageAttr.height}
          width={this.props.imageAttr.width} onError={this.handleImageError}
          className={this.props.imageAttr.className}
          onClick={this.props.onClick}
          style={this.props.imageAttr.style}
        />
      </picture>
    );
  }
}

export default Image;
